var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "157px",
    height: "157px",
    viewBox: "0 0 157 157",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E305C1A7-F323-4772-8413-CE28CC0D45D3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.5003,0 C121.8579,0 157,35.1422 157,78.5 C157,105.1586 143.7076,128.7186 123.3937,142.903 C110.6714,151.7894 95.1994,157 78.5003,157 C35.1492,157 0,121.8512 0,78.5 C0,61.8944 5.1511,46.5032 13.9499,33.821 C28.1206,13.386 51.7477,0 78.5003,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7002,0 C101.9408,0 137,35.0697 137,78.3381 C137,94.9095 131.856,110.2756 123.0795,122.9316 C110.3896,131.7997 94.957,137 78.3004,137 C35.0597,137 0,101.9232 0,58.6614 C0,42.0905 5.1374,26.7305 13.9144,14.0745 C26.6038,5.2003 42.0435,0 58.7002,0 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,0 C9.3136,0 12,2.6774 12,5.9798 L12,77.0202 C12,80.2475455 9.43432149,82.8779772 6.2249312,82.9958752 L6,83 C2.6864,83 0,80.3226 0,77.0202 L0,5.9798 C0,2.6774 2.6864,0 6,0 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5003,0 C10.0897,0 13,2.9102 13,6.5 C13,10.0898 10.0897,13 6.5003,13 C2.9103,13 0,10.0898 0,6.5 C0,2.9102 2.9103,0 6.5003,0 Z",
    id: "path-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Girar-dispositivo",
    transform: "translate(-142.000000, -165.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(142.000000, 165.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-64"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-63"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-62",
    fill: "#7174C7",
    mask: "url(#mask-2)",
    points: "-1 -1 158 -1 158 158 -1 158"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-67",
    transform: "translate(0.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-66"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-65",
    fill: "#6367C1",
    mask: "url(#mask-4)",
    points: "-1 -1 138 -1 138 138 -1 138"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-70",
    transform: "translate(74.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-69"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-68",
    fill: "#E6E7F5",
    mask: "url(#mask-6)",
    points: "-1 -1 13 -1 13 84 -1 84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-73",
    transform: "translate(74.000000, 117.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-72"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-71",
    fill: "#E6E7F5",
    mask: "url(#mask-8)",
    points: "-1 -1 14 -1 14 14 -1 14"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.fbe12086a81daa7cfdd3808cf30901a3.svg";
export { ForwardRef as ReactComponent };